import { render, staticRenderFns } from "./type-template.vue?vue&type=template&id=0dff610c&scoped=true&"
import script from "./type-template.vue?vue&type=script&lang=js&"
export * from "./type-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff610c",
  null
  
)

export default component.exports